import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="py-32 text-center px-4" data-testid="not-found-page">
      <p className="font-mono text-7xl font-bold text-[#E50914]">404</p>
      <h1 className="mt-4 font-display text-3xl font-black uppercase text-white">Pagina non trovata</h1>
      <Link to="/" className="mt-8 inline-block bg-[#E50914] text-white px-6 py-3 font-bold uppercase tracking-wider text-sm" data-testid="not-found-home-link">Torna alla home</Link>
    </section>
  );
}
